import { gql } from 'urql';

const IdvSendSMS = gql`
  mutation IdvSendSMS($input: IdvSendSMSInput!) {
    idvSendSMS(input: $input) {
      __typename
      ... on IdvSendSMSSuccess {
        id
      }

      ... on IdvSendSMSError {
        __typename
        code
        title
        message
      }
    }
  }
`;

export default IdvSendSMS;
